import classnames from 'classnames';

import avatarClasses from '../avatar/index.module.css';
import classes from './index.module.css';

export const ExploreDropDown = ({ exploreDropDownVisible }) =>
  exploreDropDownVisible ? (
    <div
      id="explorer-dropdown-content"
      className={classnames(avatarClasses.dropdown, classes.employerDropdown, {
        [avatarClasses.show]: exploreDropDownVisible,
      })}
    >
      <ul className="m-0 p-0">
        <li>
          <span>
            <a href="/careers/">By Job Titles</a>
          </span>
        </li>
        <li>
          <span>
            <a href="/colleges-and-majors/">By College Majors</a>
          </span>
        </li>
        <li>
          <span>
            <a href="/company/">By Companies</a>
          </span>
        </li>
        <li>
          <span>
            <a href="/jobs/">By Location</a>
          </span>
        </li>
        <li>
          <span>
            <a href="/advice/">Job Search Advice</a>
          </span>
        </li>
        <li>
          <span>
            <a href="/salaries/">Salaries</a>
          </span>
        </li>
      </ul>
      <div
        className={classnames(classes.dropdownTriangle, {
          'd-none': !exploreDropDownVisible,
          'd-block': exploreDropDownVisible,
        })}
      />
    </div>
  ) : null;
